export default __webpack_public_path__ + "static/media/property-scouts.edf39b1a.jpeg";